import {useSiteLanguage} from "../career/SiteLanguage";
import {corporateText} from "../career/CorporateContent";
import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import "../styles/About.css";

const About = () => {
  const {tx,lang} = useSiteLanguage();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 200);
    }
  }, [location]);

  return (
    <div className="about-page">
      <section id="fullamoda" className="about-hero">
        <div className="about-hero-content">
          <span className="about-eyebrow">Fulla Moda Kariyer</span>

          <h1>{tx("Hakkımızda")}</h1>

          <p className="about-hero-text">
            {corporateText('story',lang)}
          </p>

          <div className="about-hero-actions">
            <Link to="/joblist" className="about-primary-btn">{tx("Açık Pozisyonları İncele")}</Link>

            <a href="#iletisim" className="about-secondary-btn">{tx("İletişime Geç")}</a>
          </div>
        </div>

        <div className="about-hero-side">
          <div className="about-hero-box-grid">
            <div className="about-hero-box">
              <strong>85+</strong>
              <span>{tx("Mağaza")}</span>
            </div>

            <div className="about-hero-box">
              <strong>7</strong>
              <span>{tx("Ülke")}</span>
            </div>

            <div className="about-hero-box">
              <strong>1350+</strong>
              <span>{tx("Çalışan")}</span>
            </div>

            <div className="about-hero-box">
              <strong>{tx("Mağaza + Online")}</strong>
              <span>{tx("Alışveriş")}</span>
            </div>
          </div>
        </div>
      </section>



      <section className="about-values-section">
        <div id="vizyon" className="about-value-card">
          <span>{tx("Vizyonumuz")}</span>
          <h4>{tx("Ulaşılabilir ve tercih edilen marka olmak.")}</h4>
        </div>

        <div id="misyon" className="about-value-card">
          <span>{tx("Misyonumuz")}</span>
          <h3>{corporateText('mission',lang)}</h3>
        </div>
      </section>



      <section id="iletisim" className="about-contact-section">
        <div className="about-contact-info">
          <span className="about-eyebrow">{tx("İletişim")}</span>
          <h2>{tx("Bize Ulaşın")}</h2>

          <div className="about-contact-item">
            <strong>{tx("Adres")}</strong>
            <span>Bahçekapı Mh. 2460. Sk. No: 20 Şaşmaz-Etimesgut / Ankara</span>
          </div>

          <div className="about-contact-item">
            <strong>{tx("Telefon")}</strong>
            <a href="tel:+9008504400006">+90 850 440 00 06</a>
          </div>

          <div className="about-contact-item">
            <strong>{tx("Email")}</strong>
            <a href="mailto:info@fullamoda.com">info@fullamoda.com</a>
          </div>
        </div>

        <div className="about-map-wrapper">
          <iframe
            title={tx("Fulla Moda Konum")}
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3067.127478043731!2d32.7046278!3d39.9459952!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14d337e640f6dd75%3A0x66e27656702f14b6!2sFullamoda%20%C4%B0stanbul%20Yolu!5e1!3m2!1str!2str!4v1715860540772!5m2!1str!2str"
            allowFullScreen
            loading="lazy"
          ></iframe>
        </div>
      </section>
    </div>
  );
};

export default About;
